import React, { Component } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { H2 } from 'app/ui_components/tags';
import { Flex } from '@rebass/grid';
import ReportItem from 'app/components/ReportItem';

import { isMobile } from 'app/helpers/utils';

const Headline = styled(H2).attrs({
  weight: 900,
  size: 19,
  color: '#ccc',
})`
  position: absolute;
  bottom: 5px;
  right: ${isMobile ? 30 : 5}px;
`;

class CriteriaPreview extends Component {
  static defaultProps = {
    shiftUp: 0,
  };

  static propTypes = {
    item: PropTypes.string.isRequired,
    data: PropTypes.array.isRequired,
    shiftUp: PropTypes.number.isRequired,
    isBentobox: PropTypes.bool.isRequired,
    failCount: PropTypes.number.isRequired,
  };

  render() {
    const { item, data, shiftUp, isBentobox, failCount } = this.props;
    // show only the first negative item
    const neg = data.find(item => !item.passed);
    const pos = data.find(item => item.passed);
    const preview = isBentobox ? pos : neg;
    return (
      <Flex
        width={[1 / 1, 1 / 1, 3 / 4]}
        mx="auto"
        mt={shiftUp}
        id="previewContainer"
        style={{
          transition: 'ease 0.5s',
          background: '#fff',
          border: '1px solid #eee',
          position: 'relative',
        }}
      >
        <Headline>
          Previewing {isBentobox ? 'Feature' : 'Issue'}{' '}
          {data.indexOf(preview) + 1}/{failCount}
        </Headline>
        <ReportItem data={[preview]} item={item} preview={true} />
      </Flex>
    );
  }
}

const mapStateToProps = ({
  grade: { criteria, is_bentobox: isBentobox, fail_count: failCount },
}) => {
  // pick a key for which some have passed and some have failed
  let key = 'SEO';
  const keys = Object.keys(criteria);
  for (var i = 0; i < keys.length; i++) {
    const data = criteria[keys[i]];
    if (!isBentobox) {
      const failed = data.filter(item => !item.passed);
      if (failed.length > 0 && failed.length < data.length) {
        key = keys[i];
        break;
      }
    } else {
      const passed = data.filter(item => item.passed);
      if (passed.length > 0 && passed.length === data.length) {
        key = keys[i];
        break;
      }
    }
  }
  return {
    item: key,
    data: criteria[key],
    isBentobox,
    failCount,
  };
};

export default connect(mapStateToProps, null)(CriteriaPreview);
